// import './lib/jquery-3.0.0.min.js';
import AirDatepicker from 'air-datepicker';
import localeUk from 'air-datepicker/locale/uk';
import './lib/back-to-top.js';
import './lib/bootstrap.bundle.min.js';
import './lib/jquery-migrate-3.0.0.min.js';
import './lib/jquery.counterup.js';
// import './lib/jquery.fancybox.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import './lib/jquery.waypoints.min.js';
import './lib/lity.js';
import mixitup from 'mixitup';
import './lib/pace.js';
import './lib/parallaxie.js';
import './lib/swiper.min.js';
import './lib/wow.min.js';
import './components/single-post-views';
import './components/sticky';
import './components/form-request';
import Swiper from './lib/swiper.min.js';

const $ = jQuery;

$(document).ready(function () {
    $('[data-fancybox]').fancybox({
        mobile: {
            clickContent: 'close',
            clickSlide: 'close',
            clickOutside: 'close',
        }
    });
});

$(function () {

    var wind = $(window);

    // wow = new WOW({
    //     boxClass: 'wow',
    //     animateClass: 'animated',
    //     offset: 200,
    //     mobile: false,
    //     live: false
    // });
    // wow.init();


    // -------- dark_light themes --------
    $("#dark-icon").on("click", function () {
        $("body").addClass("dark-theme");
    })

    $("#light-icon").on("click", function () {
        $("body").removeClass("dark-theme");
    })


    // -------- dark_light themes --------
    $(".subs").on("click", function () {
        $(".nav-subs-card").addClass("show");
    })

    $(".nav-subs-card .cls").on("click", function () {
        $(".nav-subs-card").removeClass("show");
    })



    // ---------- to top -----------

    wind.on("scroll", function () {

        var bodyScroll = wind.scrollTop(),
            toTop = $(".to_top")

        if (bodyScroll > 700) {

            toTop.addClass("show");

        } else {

            toTop.removeClass("show");
        }
    });

    $('.to_top').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 0);
        return false;
    });

    /* ===============================  Preloader page  =============================== */

    // paceOptions = {
    //     ajax: true,
    //     document: true,
    //     eventLag: false
    // };

    // Pace.on('done', function () {
    //     $('#preloader').addClass("isdone");
    //     $('.loading').addClass("isdone");
    // });




    // -------- counter --------
    $('.counter').countUp({
        delay: 10,
        time: 2000
    });

    // -------- searching effect --------
    $(".search-btn-style1 , .search-btn-style2").on("click", function () {
        $(".nav-search-style1 , .nav-search-style2").slideToggle();
        $(this).children(".sOpen-btn").fadeToggle();
        $(this).children(".sClose-btn").fadeToggle();
    })


    // -------- darkLight-btn --------

    $(".darkLight-btn").on("click", ".icon", function () {
        $(this).addClass("active").siblings().removeClass("active");
    })


    // -------- posts-tabs-style4 --------

    $('.tc-posts-tabs-style4 .tc-tabs-head a').on('click', function () {
        $(this).addClass('active').siblings().removeClass('active');
    })

    var containerEl = document.querySelector('.tc-posts-tabs-style4 .tc-tabs-body');
    var mixer = containerEl ? mixitup(containerEl) : null;

});

$(document).ready(function () {

    // --------- fav btn ---------
    $(".fav-btn").on("click", function () {
        $(this).toggleClass("active");
    })

    // ------------ increase products -----------
    $(".qt-plus").click(function () {
        $(this).parent().children(".qt").html(parseInt($(this).parent().children(".qt").html()) + 1);
    });

    $(".qt-minus").click(function () {

        child = $(this).parent().children(".qt");

        if (parseInt(child.html()) > 1) {
            child.html(parseInt(child.html()) - 1);
        }

        $(this).parent().children(".full-price").addClass("minused");

    });

    $(".custom-gallery").each(function (i) {
        $(this).attr("id", "custom-gallery-" + i);

        new Swiper(`#custom-gallery-${i} .swiper-container`, {
            slidesPerView: 1,
            spaceBetween: 30,
            speed: 1000,
            pagination: {
                el: `#custom-gallery-${i} .swiper-pagination`,
                type: 'fraction',
            },
            navigation: {
                nextEl: `#custom-gallery-${i} .swiper-button-next`,
                prevEl: `#custom-gallery-${i} .swiper-button-prev`,
            },
            mousewheel: false,
            keyboard: true,
            // autoplay: {
            //     delay: 5000,
            // },
            loop: false,
            autoHeight: true,
            on: {
                init: function () {
                    updatePaginationMargin(this);
                },
                slideChange: function () {
                    updatePaginationMargin(this);
                }
            }
        });

        function updatePaginationMargin(swiper) {
            const swiperEl = document.querySelector(`#custom-gallery-${i}`);
            const activeSlide = swiperEl.querySelector('.swiper-slide-active');
            const description = activeSlide.querySelector('.description');
            const pagination = swiperEl.querySelector(`.swiper-pagination`);
            const prev = swiperEl.querySelector(`.swiper-button-next`);
            const next = swiperEl.querySelector(`.swiper-button-prev`);

            if (description) {
                const descriptionHeight = description.clientHeight;
                pagination.style.marginBottom = `${descriptionHeight}px`;
                prev.style.top = `calc(50% - ${descriptionHeight - prev.clientHeight}px`;
                next.style.top = `calc(50% - ${descriptionHeight - next.clientHeight}px`;
            }
        }
    });
});

// ---------- hover dropdown -----------
const $dropdown = $(".dropdown");
const $dropdownToggle = $(".dropdown-toggle");
const $dropdownMenu = $(".dropdown-menu");
const showClass = "show";


$(window).on("load resize", function () {
    if (this.matchMedia("(min-width: 768px)").matches) {
        $dropdown.hover(
            function () {
                const $this = $(this);
                $this.addClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "true");
                $this.find($dropdownMenu).addClass(showClass);
            },
            function () {
                const $this = $(this);
                $this.removeClass(showClass);
                $this.find($dropdownToggle).attr("aria-expanded", "false");
                $this.find($dropdownMenu).removeClass(showClass);
            }
        );
    } else {
        $dropdown.off("mouseenter mouseleave");
    }
});





// ------------ swiper sliders -----------
$(document).ready(function () {

    // ------------ breaking-news slider -----------
    var swiper = new Swiper('.tc-breaking-news-style1 .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 50,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-slider-style1 .swiper-button-next',
            prevEl: '.tc-slider-style1 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    // ------------ breaking-news slider -----------
    var swiper = new Swiper('.tc-breaking-news-slider4 .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 30,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-breaking-news-slider4 .swiper-button-next',
            prevEl: '.tc-breaking-news-slider4 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    // ------------ trends-news slider -----------
    var swiper = new Swiper('.tc-trends-news-slider1 .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-trends-news-slider1 .swiper-button-next',
            prevEl: '.tc-trends-news-slider1 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 6000,
        },
        loop: true,
    });

    // ------------ trends-news slider -----------
    var swiper = new Swiper('.tc-trends-news-slider3 .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-trends-news-slider3 .swiper-button-next',
            prevEl: '.tc-trends-news-slider3 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 6000,
        },
        loop: true,
    });

    // ------------ breaking-news slider -----------
    var swiper = new Swiper('.tc-google-stories-slider1 .swiper-container', {
        slidesPerView: 8,
        spaceBetween: 20,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-google-stories-slider1 .swiper-button-next',
            prevEl: '.tc-google-stories-slider1 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: false,
        breakpoints: {
            0: {
                slidesPerView: 2,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 4,
            },
            991: {
                slidesPerView: 6,
            },
            1200: {
                slidesPerView: 8,
            }
        }
    });

    // ------------ trends-news slider -----------
    var swiper = new Swiper('.tc-video-slider1 .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-video-slider1 .swiper-button-next',
            prevEl: '.tc-video-slider1 .swiper-button-prev',
        },
        observer: true,
        observeParents: true,
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 5000,
        },
        loop: true,
    });

    // ------------ trends-news slider -----------
    var swiper = new Swiper('.tc-header-slider2 .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-header-slider2 .swiper-button-next',
            prevEl: '.tc-header-slider2 .swiper-button-prev',
        },
        observer: true,
        observeParents: true,
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 5000,
        },
        loop: true,
    });

    // ------------ columnist slider1 -----------
    var swiper = new Swiper('.columnist-slider1 .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 50,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.columnist-slider1 .swiper-button-next',
            prevEl: '.columnist-slider1 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    // ------------ columnist slider -----------
    var swiper = new Swiper('.columnist-slider2 .swiper-container', {
        slidesPerView: 4,
        spaceBetween: 10,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.columnist-slider2 .swiper-button-next',
            prevEl: '.columnist-slider2 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });

    // ------------ trends-news slider -----------
    var swiper = new Swiper('.tc-trends-news-slider2 .swiper-container', {
        // slidesPerView: 3,
        spaceBetween: 30,
        speed: 1000,
        pagination: {
            el: ".tc-trends-news-slider2 .swiper-pagination",
            clickable: true,
        },
        navigation: false,
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: false,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });

    // ------------ popular-topics slider -----------
    var swiper = new Swiper('.tc-popular-topics-slider2 .swiper-container', {
        // slidesPerView: 3,
        spaceBetween: 30,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-popular-topics-slider2 .swiper-button-next',
            prevEl: '.tc-popular-topics-slider2 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 2,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 3,
            },
            991: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 6,
            }
        }
    });

    // ------------ columnist slider -----------
    var swiper = new Swiper('.tc-hot-videos-slider2 .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 50,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-hot-videos-slider2 .swiper-button-next',
            prevEl: '.tc-hot-videos-slider2 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    // ------------ home3 header slider -----------
    var swiper = new Swiper('.tc-header-slider-style3 .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: "fade",
        speed: 1000,
        pagination: {
            el: ".tc-header-slider-style3 .swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.tc-header-slider-style3 .swiper-button-next',
            prevEl: '.tc-header-slider-style3 .swiper-button-prev',
        },
        observer: true,
        observeParents: true,
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 5000,
        },
        loop: true,
    });

    // ------------ popular-categories slider -----------
    var swiper = new Swiper('.tc-popular-categories-slider3 .swiper-container', {
        slidesPerView: 6,
        spaceBetween: 30,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-popular-categories-slider3 .swiper-button-next',
            prevEl: '.tc-popular-categories-slider3 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 4,
            },
            991: {
                slidesPerView: 5,
            },
            1200: {
                slidesPerView: 6,
            }
        }
    });

    // ------------ editor’s-choice slider -----------
    var swiper = new Swiper('.tc-editors-choice-slider3 .swiper-container', {
        slidesPerView: 6,
        spaceBetween: 30,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-editors-choice-slider3 .swiper-button-next',
            prevEl: '.tc-editors-choice-slider3 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 3,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });

    // ------------ tc-latest-posts-slider3 -----------
    var swiper = new Swiper('.tc-latest-posts-slider3 .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 30,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-latest-posts-slider3 .swiper-button-next',
            prevEl: '.tc-latest-posts-slider3 .swiper-button-prev',
        },
        scrollbar: {
            el: '.tc-latest-posts-slider3 .swiper-scrollbar',
            hide: false,
            clickable: true,
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: false,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    // ------------ tc-editors-pick-slider -----------
    var swiper = new Swiper('.tc-editors-pick-slider .swiper-container', {
        // slidesPerView: 3,
        spaceBetween: 60,
        speed: 1000,
        pagination: {
            el: ".tc-editors-pick-slider .swiper-pagination",
            clickable: true,
        },
        navigation: false,
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: false,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    // ------------ tc-editors-pick-slider -----------
    var swiper = new Swiper('.tc-breaking-news-slider5 .swiper-container', {
        // slidesPerView: 3,
        spaceBetween: 30,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-breaking-news-style5 .swiper-button-next',
            prevEl: '.tc-breaking-news-style5 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 2,
            }
        }
    });

    // ------------ tc-editors-pick-slider -----------
    var swiper = new Swiper('.tc-breaking-news-slider6 .swiper-container', {
        // slidesPerView: 3,
        spaceBetween: 30,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-breaking-news-style6 .swiper-button-next',
            prevEl: '.tc-breaking-news-style6 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 2,
            }
        }
    });

    // ------------ home5 overlay slider -----------
    var swiper = new Swiper('.tc-post-overlay-slider5 .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-post-overlay-slider5 .swiper-button-next',
            prevEl: '.tc-post-overlay-slider5 .swiper-button-prev',
        },
        observer: true,
        observeParents: true,
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 5000,
        },
        loop: true,
    });

    // ------------ home5 videos slider -----------
    var swiper = new Swiper('.tc-post-videos-slider5 .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-post-videos-slider5 .swiper-button-next',
            prevEl: '.tc-post-videos-slider5 .swiper-button-prev',
        },
        observer: true,
        observeParents: true,
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 5000,
        },
        loop: true,
    });

    // ------------ trends-news slider -----------
    var swiper = new Swiper('.tc-trends-news-slider6 .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 50,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-trends-news-slider6 .swiper-button-next',
            prevEl: '.tc-trends-news-slider6 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    // ------------ trends-news slider -----------
    var swiper = new Swiper('.tc-latest-posts-slider4 .swiper-container', {
        // slidesPerView: 3,
        spaceBetween: 50,
        speed: 1000,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: '.tc-latest-posts-slider4 .swiper-button-next',
            prevEl: '.tc-latest-posts-slider4 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });

    // ------------ results-slider1 slider -----------
    var swiper = new Swiper('.results-slider1 .swiper-container', {
        // direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.results-slider1 .swiper-button-next',
            prevEl: '.results-slider1 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: false,
    });

    // ------------ tc-featured-news slider8 -----------
    var swiper = new Swiper('.tc-featured-news-slider8 .swiper-container', {
        // slidesPerView: 3,
        spaceBetween: 10,
        speed: 1000,
        pagination: {
            el: ".tc-featured-news-slider8 .swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: '.tc-featured-news-slider8 .swiper-button-next',
            prevEl: '.tc-featured-news-slider8 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });


    // ------------ tc-featured-news slider8 -----------
    var swiper = new Swiper('.tc-breaking-news-slider8 .swiper-container', {
        // slidesPerView: 3,
        spaceBetween: 30,
        speed: 1000,
        pagination: {
            el: ".tc-breaking-news-slider8 .swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: '.tc-breaking-news-slider8 .swiper-button-next',
            prevEl: '.tc-breaking-news-slider8 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 5,
            }
        }
    });

    // ------------ columnist slider8 -----------
    var swiper = new Swiper('.columnist-slider8 .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 80,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.columnist-slider8 .swiper-button-next',
            prevEl: '.columnist-slider8 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    // ------------ columnist slider8 -----------
    var swiper = new Swiper('.tc-sponsored-slider8 .swiper-container', {
        // slidesPerView: 2,
        spaceBetween: 30,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-sponsored-slider8 .swiper-button-next',
            prevEl: '.tc-sponsored-slider8 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 7000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 1,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 2,
            }
        }
    });

    // ------------ columnist slider8 -----------
    var swiper = new Swiper('.tc-popular-posts-blog-slider9 .swiper-container', {
        // slidesPerView: 2,
        spaceBetween: 32,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-popular-posts-blog-slider9 .swiper-button-next',
            prevEl: '.tc-popular-posts-blog-slider9 .swiper-button-prev',
        },
        watchOverflow: true,
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 7000,
        },
        loop: false,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 3,
            },
            991: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });

    // ------------ columnist slider8 -----------
    var swiper = new Swiper('.tc-next-prev-post-slider .swiper-container', {
        // slidesPerView: 2,
        spaceBetween: 60,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-next-prev-post-slider .swiper-button-next',
            prevEl: '.tc-next-prev-post-slider .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: false,
        loop: false,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 2,
            }
        }
    });

    // ------------ columnist slider8 -----------
    var swiper = new Swiper('.tc-single-post-slider-style1 .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 1000,
        pagination: {
            el: '.tc-single-post-slider-style1 .swiper-pagination',
            type: 'fraction',
        },
        navigation: {
            nextEl: '.tc-single-post-slider-style1 .swiper-button-next',
            prevEl: '.tc-single-post-slider-style1 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 5000,
        },
        loop: true,
    });

    // ------------ columnist slider8 -----------
    var swiper = new Swiper('.tc-contact-slider .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 1000,
        pagination: {
            el: '.tc-contact-slider .swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.tc-contact-slider .swiper-button-next',
            prevEl: '.tc-contact-slider .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 5000,
        },
        loop: true,
    });

    // ------------ columnist slider8 -----------
    var swiper = new Swiper('.tc-breaking-news-slider2 .swiper-container', {
        // slidesPerView: 2,
        spaceBetween: 30,
        speed: 1000,
        pagination: false,
        navigation: false,
        mousewheel: false,
        keyboard: true,
        autoplay: true,
        loop: false,
        scrollbar: {
            el: '.tc-breaking-news-slider2 .swiper-scrollbar',
            hide: false,
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            787: {
                slidesPerView: 3,
            },
            991: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 5,
            }
        }
    });

    // ------------ gallery-thumbs-slider -----------
    var galleryThumbs = new Swiper('.product .gallery-thumbs', {
        spaceBetween: 20,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        direction: 'vertical',
    });
    var galleryTop = new Swiper('.product .gallery-top', {
        spaceBetween: 10,
        navigation: false,
        thumbs: {
            swiper: galleryThumbs
        }
    });

    // ------------ related-postes-slider -----------
    var swiper = new Swiper('.related-products-slider .swiper-container', {
        slidesPerView: 5,
        spaceBetween: 24,
        // centeredSlides: true,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.related-products-slider .swiper-button-next',
            prevEl: '.related-products-slider .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 1,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    // ------------ related-postes-slider -----------
    var swiper = new Swiper('.tc-google-stories-slider10 .swiper-container', {
        slidesPerView: 5,
        spaceBetween: 15,
        // centeredSlides: true,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-google-stories-slider10 .swiper-button-next',
            prevEl: '.tc-google-stories-slider10 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 1,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 5,
            }
        }
    });

    // ------------ tc-about-history-slider -----------
    var swiper = new Swiper('.tc-about-history-slider .swiper-container', {
        slidesPerView: 3.1,
        spaceBetween: 50,
        // centeredSlides: true,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-about-history .swiper-button-next',
            prevEl: '.tc-about-history .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: false,
        breakpoints: {
            0: {
                spaceBetween: 16,
                slidesPerView: 1.1,
            },
            480: {
                spaceBetween: 16,
                slidesPerView: 1.1,
            },
            787: {
                spaceBetween: 16,
                slidesPerView: 2.1,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3.05,
            }
        }
    });

    // ------------ related-postes-slider -----------
    var swiper = new Swiper('.tc-trends-news-slider10 .swiper-container', {
        slidesPerView: 5,
        spaceBetween: 0,
        centeredSlides: true,
        speed: 1000,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.tc-trends-news-slider10 .swiper-button-next',
            prevEl: '.tc-trends-news-slider10 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 4000,
        },
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1,
                centeredSlides: false,
            },
            480: {
                slidesPerView: 1,
                centeredSlides: false,
            },
            787: {
                slidesPerView: 2,
            },
            991: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });


    // ------------ trends-news slider -----------
    var swiper = new Swiper('.tc-header-slider10 .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-header-slider10 .swiper-button-next',
            prevEl: '.tc-header-slider10 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 6000,
        },
        loop: true,
    });

    // ------------ trends-news slider -----------
    var swiper = new Swiper('.tc-hot-videos-slider11 .swiper-container', {
        slidesPerView: 1,
        effect: "fade",
        spaceBetween: 0,
        speed: 1000,
        pagination: false,
        navigation: {
            nextEl: '.tc-hot-videos-slider11 .swiper-button-next',
            prevEl: '.tc-hot-videos-slider11 .swiper-button-prev',
        },
        mousewheel: false,
        keyboard: true,
        autoplay: {
            delay: 6000,
        },
        loop: true,
    });


});



// ------------ loader -----------
$(window).on("load", function () {
    $(".loading-page").fadeOut(1000);
});


// ------------ working in desktop -----------
if ($(window).width() > 991) {
    $('.parallaxie').parallaxie({
    });
}

$('#searchsubmit').on('click', function (e) {
    if ($(window).width() > 992) {
        if ($(this).hasClass('not-submit')) {
            e.preventDefault()
            $('.header-search').toggleClass('open')
            $(this).removeClass('not-submit')
            $('#s').trigger('focus');
        }
    }
})

$('#s').on('focus', function () {
    var input = $(this)[0];
    var textLength = input.value.length;
    input.setSelectionRange(textLength, textLength);
});

$('.close-search').on('click', function (e) {
    e.preventDefault()
    $('.header-search').toggleClass('open')
    $('#searchsubmit').addClass('not-submit')
})

$(document).on('click', (event) => {
    const headerSearch = $('.header-search');
    const targetElement = event.target;

    if (!headerSearch.is(targetElement) && !headerSearch.has(targetElement).length) {
        headerSearch.removeClass('open');
        $('#searchsubmit').addClass('not-submit')
    }
});

let pickerToggle = true;
const picker = new AirDatepicker('#calendar', {
    locale: localeUk,
    dateFormat: 'yyyy/MM/dd',
    buttons: ['today'],
    onSelect(selected) {

        const currentUrl = new URL(window.location.href);
        const searchParam = currentUrl.searchParams.get('s');
        const parts = selected.formattedDate.split('/');
        const formattedDate = `${parts[0]}-${parts[1]}-${parts[2]}`;
        let url = `/${selected.formattedDate}/?date=${formattedDate}`;

        if (searchParam) {
            url += `&s=${searchParam}`;
        }

        const calendarID = selected.datepicker.$el.id

        fetch(url)
            .then(response => {
                if (response.status === 200) {
                    if (pickerToggle) {
                        window.location.href = url;
                    } else {
                        pickerToggle = true;
                    }
                } else {
                    $('.calendar-error').remove()
                    const htmlError = `
						<div class="calendar-error alert alert-danger mt-1">За цю дату новин немає.</div>
					`
                    $(`#${calendarID}`).append(htmlError);
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }
});

if (document.querySelector('#calendar')) {
    const params = new URLSearchParams(window.location.search);
    const dateValue = params.get("date");

    if (dateValue) {
        pickerToggle = false;
        let dateObj = new Date(dateValue);
        dateObj.setDate(dateObj.getDate());
        picker.selectDate(dateObj);
        picker.setViewDate(dateObj);
    }

    const btn = document.querySelector('.air-datepicker-button');
    btn.addEventListener('click', () => {
        picker.selectDate(new Date());
        picker.setViewDate(new Date());
    })
}

//===================== BANNERS =====================//
// Функция для установки куки
function setCookie(name, value, hours) {
    const expires = new Date();
    expires.setTime(expires.getTime() + hours * 60 * 60 * 1000);
    console.log(expires);
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
}

// Функция для получения значения куки
function getCookie(name) {
    const keyValue = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}
// FIXED BANNER
const fixedBanner = document.querySelector('.bnr-fixed');

if (fixedBanner) {
    // Check if the user has previously closed the banner
    if (sessionStorage.getItem('bannerClosed') === 'true') {
        fixedBanner.style.display = 'none';
    }
    fixedBanner.addEventListener('click', (e) => {
        const closeButton = e.target.closest('button');
        const linkButton = e.target.closest('a');

        if (closeButton || linkButton) {
            // Hide the banner and set the flag in sessionStorage
            fixedBanner.style.display = 'none';
            sessionStorage.setItem('bannerClosed', 'true');
        }
    });
}

// POPUP BANNER
document.addEventListener('DOMContentLoaded', () => {
    const popupBannersDesktop = document.querySelector('dialog.bnr-popup.desk');
    const popupBannersMobile = document.querySelector('dialog.bnr-popup.mob');
    const activePopup = window.innerWidth > 415 ? popupBannersDesktop : popupBannersMobile;

    if (activePopup) {
        let closeBtn = activePopup.querySelector('[data-close]');
        closeBtn.addEventListener("click", () => closePopup());

        // Закрытие баннера при клике на ближайший тег <a>
        activePopup.addEventListener("click", (e) => {
            const linkButton = e.target.closest('a');
            if (linkButton) {
                closePopup();
            }
        });


        // Проверяем куки для определения, нужно ли отображать баннер
        const bannerCookieName = 'banner_displayed';
        const bannerCookieValue = getCookie(bannerCookieName);

        if (!bannerCookieValue) {
            setTimeout(() => {
                showPopup();
                setCookie(bannerCookieName, 'displayed', 2);
            }, 15000);
        }

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" || e.key === "Esc") {
                if (activePopup.open) {
                    e.preventDefault();
                }
            }
        });
    }

    function showPopup() {
        document.documentElement.style.overflow = 'hidden';
        activePopup.showModal();
    }

    function closePopup() {
        document.documentElement.style.overflow = '';
        activePopup.close();
    }
});

